import { Link } from 'react-router-dom';
import "../BackgroundImages.css"

const CourseCategoryList = () => {
  const categories = [
    { title: 'Business & Management', img: "https://www.growniverse.com/images//Business.webp", },
    { title: 'Health & Nutrition', img: "https://www.growniverse.com/images//Health.webp" },
    { title: 'IT & Software', img: "https://www.growniverse.com/images//it.webp" },
    { title: 'Personality Development', img: "https://www.growniverse.com/images//Personality.webp" },
    { title: 'Share Market & Crypto Currency', img: "https://www.growniverse.com/images//ShareMarket.webp" },
    { title: 'Communication & Presentation Skills', img: "https://www.growniverse.com/images//Communication.webp" },
    { title: 'IELTS & English Speaking', img: "https://www.growniverse.com/images//IELETS.webp" },
    { title: 'LAW Management', img: "https://www.growniverse.com/images//Law.webp" },
    { title: 'Life Skills', img: "https://www.growniverse.com/images//LikeSkills.webp" },
    { title: 'Money Management', img: "https://www.growniverse.com/images//MoneyManagement.webp" },
  ];

  return (
    <section className="space-ptb BgSpace" >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="section-title text-center"> 
              <h2 style={{color:"white"}}>Choose Your Next Step to Success</h2>
              <p>
              The World need Dreamer's and the World Need Doers but above All the World Need Dreamer's Who Do.
              </p>
            </div>
          </div>
        </div>
        {/* <FallingEffect /> */}
        <div className="row">
          {categories.slice(0, 4).map((category, index) => (
            <div key={index} className=" col-md-3 col-sm-6">
              <Link to={'#'}>
                <div className="processing-box categories">
                  <img className="img-fluid" src={category.img} alt={category.title} />
                  <h6 className="categories-title">{category.title}</h6>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className="row">
          {categories.slice(4).map((category, index) => (
            <div key={index} className="col-md-3 col-sm-6">
              <Link to={'#'}>
                <div className="processing-box categories"  style={{height:"auto"}}>
                  <img className="img-fluid" src={category.img} alt={category.title} style={{height:"auto"}} />
                  <h6 className="categories-title">{category.title}</h6>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseCategoryList;
